module.exports = __webpack_public_path__ + "static/img/download1-2.5f31ab6a.png";